import { notification } from 'antd';

notification.config({ placement: 'bottomLeft', bottom: 48 });

export const Notify = notification;
